"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Survey = void 0;
const mocks_1 = require("../../mocks");
const property_1 = require("../../decorators/property");
const class_validator_1 = require("class-validator");
class Survey extends mocks_1.Model {
}
exports.Survey = Survey;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)({ type: mocks_1.ObjectId, index: true }),
    __metadata("design:type", String)
], Survey.prototype, "visitId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], Survey.prototype, "appServiceQuality", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], Survey.prototype, "videoCallQuality", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], Survey.prototype, "doctorQuality", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(500),
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)({ default: '' }),
    __metadata("design:type", String)
], Survey.prototype, "extraMessage", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)({ type: mocks_1.ObjectId, index: true }),
    __metadata("design:type", String)
], Survey.prototype, "userId", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'userId', ref: 'User' }),
    __metadata("design:type", Function)
], Survey.prototype, "user", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'visitId', ref: 'Visit' }),
    __metadata("design:type", Function)
], Survey.prototype, "visit", void 0);
